import React from 'react';

const SpamFolderHint = () => (
  <div className="auth-spam-warning">
    <strong>Não encontrou o email?</strong> Verifique sua pasta de{' '}
    <strong>Spam</strong> ou <strong>Lixo eletrônico</strong> e marque como
    &quot;Não é spam&quot; para receber os próximos normalmente.
  </div>
);

export default SpamFolderHint;
